import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiEndpoints as API } from 'src/config/api-endpoints';
import { environment as ENV } from 'src/environments/environment';
import { ONLSessionDetails, WalletDetails, WalletPayload } from '../models/user.interface';
import { BehaviorSubject, Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { WalletSummary } from '../models/wallet-summary.interface';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  private options = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    })
  };

  walletDetails: WalletDetails = {};
  ONLSessionDetails: ONLSessionDetails = {};

  private walletSummarySubject = new BehaviorSubject<WalletSummary | null>(null);
  walletSummary$ = this.walletSummarySubject.asObservable();

  constructor(
    private http: HttpClient
  ) { }

      // Method to manually update the BehaviorSubject
      setWalletSummary(summary: WalletSummary) {
          this.walletSummarySubject.next(summary);
      }

  // Getter functions
  getWalletDetails() {
    this.walletDetails = JSON.parse(sessionStorage.getItem('walletDetails')!);
    return this.walletDetails;
  }

  getONLSessionDetails() {
    if(sessionStorage.getItem('ONLWalletSession')!=null)
    this.ONLSessionDetails = JSON.parse(sessionStorage.getItem('ONLWalletSession'));
  else{
    this.ONLSessionDetails = JSON.parse(sessionStorage.getItem('PPIWalletSession'));
  }
    return this.ONLSessionDetails;
  }

  // API Calls
  // getWalletSummary(details: WalletPayload) { // I used an interface here, but angular/typescript is super lenient to the 'any' type, so you really don't have to.
  //   let wallettoken=sessionStorage.getItem("walletheaders");
  //   let httpOptions = {
  //     headers: new HttpHeaders({
  //       "Access-Control-Allow-Methods": "POST, GET",
  //       'Content-Type': 'application/json',
  //       "Authorization": "bearer " + wallettoken
  //     }),
  //   };
  //   return this.http.post<any>(`${ENV.walletbaseApiUrl}${API.getWalletSummary}`, details, httpOptions);
  // }

   getWalletSummary(details: WalletPayload): Observable<any> {
        let wallettoken = sessionStorage.getItem("walletheaders");
        let httpOptions = {
            headers: new HttpHeaders({
                "Access-Control-Allow-Methods": "POST, GET",
                'Content-Type': 'application/json',
                "Authorization": "bearer " + wallettoken
            }),
        };
        return this.http.post<any>(`${ENV.walletbaseApiUrl}${API.getWalletSummary}`, details, httpOptions).pipe(
            tap(summary => {
                // Determine the active wallet and store it
                let activeWallet = summary.onl?.wallet || summary.ppi?.wallet || summary.wallet;
                const walletToStore = activeWallet || {};
                 sessionStorage.setItem('walletDetails', JSON.stringify(walletToStore));
                // if (activeWallet) {
                //     sessionStorage.setItem('walletDetails', JSON.stringify(activeWallet));
                // }
                // Broadcast the new summary to all subscribers
                this.walletSummarySubject.next(summary);
            })
        );
    }

     refreshWalletSummary(): Observable<any> {
        // const walletID = JSON.parse(sessionStorage.getItem('WalletID')!);
        // const walletRole = JSON.parse(sessionStorage.getItem('WalletRole')!);
        // const sessionID = sessionStorage.getItem('SessionID');

        const walletID = sessionStorage.getItem('WalletID'); 
    const walletRole = sessionStorage.getItem('WalletRole'); 
    const sessionID = sessionStorage.getItem('SessionID');
        
    //    const details = { walletID, walletRole, sessionID };

    const details = { 
        walletID: walletID || '', 
        walletRole: walletRole || '', 
        sessionID: sessionID || '' 
    };
        
        return this.getWalletSummary(details);
    }

  getAutoPaySequence(details: any) {
    let wallettoken=sessionStorage.getItem("walletheaders");
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Methods": "POST, GET",
        'Content-Type': 'application/json',
        "Authorization": "bearer " + wallettoken
      }),
    };
    return this.http.post<any>(`${ENV.walletbaseApiUrl}${API.getAutoPaySequence2}`, details, httpOptions);
  }

  isRewardEligible() {
    let walletDetails = JSON.parse(sessionStorage.getItem('walletDetails'));
    return walletDetails?.rewardEligible == 'True' ? true : false;
  }
}
